import { all, call, takeEvery, put, delay } from "redux-saga/effects";
import customerActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import Cookies from "js-cookie";
import capRegistrationActions from "./actions";
import commonActions from "../common/actions";

const capSagas = function* () {
  yield all([
    yield takeEvery(capRegistrationActions.GET_CAP_COURSE_DOCUMENT, getCapCourseDocument),
    yield takeEvery(capRegistrationActions.CREATE_CAP_COURSE_DOCUMENT, createCapCourseDocument),
    yield takeEvery(capRegistrationActions.UPDATE_CAP_COURSE_DOCUMENT, updateCapCourseDocument),
    yield takeEvery(capRegistrationActions.SET_ACTIVE_CAP_COURSE_DOC, setActiveCapCourse),
      
    yield takeEvery(capRegistrationActions.CREATE_CAP_COURSE, createCapCourse),
    yield takeEvery(capRegistrationActions.UPDATE_CAP_COURSE, updateCapCourse),
    yield takeEvery(capRegistrationActions.UPDATE_CAP_COURSE_STATUS, updateCapCourseStatus),
    yield takeEvery(capRegistrationActions.GET_ALL_CAP_COURSE, getAllCapCourse),

    yield takeEvery(capRegistrationActions.CREATE_CAP_CANDIDATURE, createCapCandidatures),
    yield takeEvery(capRegistrationActions.GET_CAP_CANDIDATURE, getCapCandidatures),
    yield takeEvery(capRegistrationActions.UPDATE_CAP_CANDIDATURE, updateCapCandidatures),

    yield takeEvery(capRegistrationActions.UPLOAD_DOCUMENT, uploadDocument),
    yield takeEvery(capRegistrationActions.REMOVE_DOCUMENT, removeDocument),

    yield takeEvery(capRegistrationActions.CREATE_CAP_CATEGORY, createCapCategories),
    yield takeEvery(capRegistrationActions.UPDATE_CAP_CATEGORY, updateCapCategories),
    yield takeEvery(capRegistrationActions.GET_CAP_CATEGORY, getCapCategories),

    
  ]);
};


const createCapCourseDocument = function* (data) {
  const { payload } = data;
  const { navigate, sampleurl, ...formDatas } = payload;


  const formData = new FormData();

  for (let key in formDatas.data) {
    formData.append(key, formDatas.data[key]);
  }

  if (sampleurl) {
    formData.append("sampleurl", sampleurl);
  }

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/cap-document`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    );

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      navigate(
        `/${Cookies.get("mhet_mst_project")}/cap-course-document-master?page=document-list`
      );
      yield put({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT });
    }

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const updateCapCourseDocument = function* (data) {
  const { payload } = data;
  const { navigate, sampleurl, ...formDatas } = payload;

  
  const formData = new FormData();
  
  for (let key in formDatas.data) {
    formData.append(key, formDatas.data[key]);
  }
  
  if (sampleurl) {
    formData.append("sampleurl", sampleurl);
  }
  

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
        axios.put(`${API_URL}/backoffice/cap-document/${payload?.data?.documenttypeid}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      );
  
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      navigate(
        `/${Cookies.get("mhet_mst_project")}/cap-course-document-master?page=document-list`
      );
      yield put({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT });
    }
   
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};


const setActiveCapCourse = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.put(
        `${API_URL}/backoffice/cap-document/updateactive/${payload?.data?.documenttypeid}`,
        payload?.data
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      yield put({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT });
      yield put({
        type: commonActions.SET_SHOW_MODAL,
        payload: { show: false, type: null, method: null, data: null },
      });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
     ;
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};





const getCapCourseDocument = function* (data) {
  const { payload } = data;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/cap-document`)
    );
    if (result) {
      yield put({
        type: capRegistrationActions.SET_CAP_COURSE_DOCUMENT,
        payload: result?.data?.result,
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};


const getCapCandidatures = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/cap-candidature`)
    );
    if (result) {
      yield put({
        type: capRegistrationActions.SET_CAP_CANDIDATURE,
        payload: result?.data?.result,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}
  const createCapCourse =   function*(data){
    const { payload } = data;
    const { resetForm, navigate,reset } = payload;
  
    const formData = new FormData();
    const { data: formValues } = payload;
  
    // Append all form fields to FormData
    for (const key in formValues) {
      if (
        key !== "templatedocs" &&
        key !== "scorecarddocs" &&
        key !== "document"
      ) {
        formData.append(key, formValues[key]);
      }
    }
  
    // Append files if present
    if (formValues?.templatedocs?.file) {
      formData.append("templatedocs", formValues.templatedocs.file);
    }
    if (formValues?.scorecarddocs?.file) {
      formData.append("scorecarddocs", formValues.scorecarddocs.file);
    }
    if (formValues?.document?.file) {
      formData.append("document", formValues.document.file);
    }
  
    // formData.append("capcourseid", 0);
    // formData.append("createdby", 13);

    try {
      const result = yield call(() =>
        axios.post(`${API_URL}/backoffice/cap-coursedetails/coursemanagement/createcourse`, formData)
      );
  
  
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
  
      if (result?.data?.statusCode === 200) {
        // resetForm();

        
        navigate(
          `/${Cookies.get("mhet_mst_project")}/cap-course-management?page=capcourselist`
        );
        // yield put({ type: masterActions.GET_CAP_COURSE_LIST }); // Optional: define this action
        yield put({
          type: commonActions.SET_SHOW_MODAL,
          payload: { show: false, type: null, method: null, data: null },
        });
      }
  
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
    } catch (error) {
      console.error("CAP Course Create Error:", error);
      yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Failed to create CAP course",
        },
      });
    }
  }
  const updateCapCourse =   function*(data){
    const { payload } = data;
    const { resetForm, navigate,reset } = payload;
  
    const formData = new FormData();
    const { data: formValues } = payload;
  
    // Append all form fields to FormData
    for (const key in formValues) {
      if (
        key !== "templatedocs" &&
        key !== "scorecarddocs" &&
        key !== "document"
      ) {
        formData.append(key, formValues[key]);
      }
    }
  
    // Append files if present
    if (formValues?.templatedocs?.file) {
      formData.append("templatedocs", formValues.templatedocs.file);
    }
    if (formValues?.scorecarddocs?.file) {
      formData.append("scorecarddocs", formValues.scorecarddocs.file);
    }
    if (formValues?.document?.file) {
      formData.append("document", formValues.document.file);
    }
  
    // formData.append("capcourseid", 0);
    // formData.append("createdby", 13);

    try {
      const result = yield call(() =>
        axios.post(`${API_URL}/backoffice/cap-coursedetails/coursemanagement/updatecourse`, formData)
      );  
  
  
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode == 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
  
      if (result?.data?.statusCode == 200) {
        // resetForm();

        
        navigate(
          `/${Cookies.get("mhet_mst_project")}/cap-course-management?page=capcourselist`
        );
        // yield put({ type: masterActions.GET_CAP_COURSE_LIST }); // Optional: define this action
        yield put({
          type: commonActions.SET_SHOW_MODAL,
          payload: { show: false, type: null, method: null, data: null },
        });
      }
  
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
    } catch (error) {
      console.error("CAP Course Create Error:", error);
      yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Failed to create CAP course",
        },
      });
    }
  }

const updateCapCandidatures = function* (data) {
  const { payload } = data;
  // console.log(payload)
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.put(`${API_URL}/backoffice/cap-candidature/${payload?.data?.candidatureid}`, payload?.data)
    );
    // console.log(result)
    if (result?.data?.statusCode === 200) {
      yield put({
        type: capRegistrationActions.GET_CAP_CANDIDATURE,
        // payload: result?.data?.result,
      });
      payload?.navigate(
        `/${Cookies.get(
          "mhet_mst_project"
        )}/cap-candidature-document?page=candidature-documentlist`
      )
      
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}

const createCapCandidatures = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/cap-candidature`, {
        candidature: payload?.data?.candidature,
        documentid: payload?.data?.documentid,
        userid: payload?.data?.userid,
        candidaturenotes : payload?.data?.candidaturenotes,
      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: capRegistrationActions.GET_CAP_CANDIDATURE,
        // payload: result?.data?.result,
      });
      payload?.navigate(
        `/${Cookies.get(
          "mhet_mst_project"
        )}/cap-candidature-document?page=candidature-documentlist`
      )
   
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}

const uploadDocument = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const formData = new FormData()
    formData.append("sampleurl", payload?.file);
    formData.append("userid", payload?.userid);
    formData.append("documenttype", payload?.documenttype);
    formData.append("status", payload?.status);
    formData.append("isactive", payload?.isactive);
    formData.append("coursenotes", payload?.coursenotes);

    const result = yield call(() =>
      axios.put(`${API_URL}/backoffice/cap-document/upload/${payload?.documenttypeid}`, formData)
    );
    if (result) {
      yield put({
        type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT,
        // payload: result?.data?.result,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}

const removeDocument = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    // const formData = new FormData()
    // formData.append("sampleurl", payload?.file);
    // formData.append("userid", payload?.userid);
    // formData.append("documenttype", payload?.documenttype);
    const result = yield call(() =>
      axios.put(`${API_URL}/backoffice/cap-document/remove/${payload?.documenttypeid}`, {
        userid: payload?.userid,
        documenttype: payload?.documenttype,
        status: payload?.status,
        isactive: payload?.isactive,
        coursenotes : payload?.coursenotes,
      })
    );
    if (result) {
      yield put({
        type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT,
        // payload: result?.data?.result,
      });
    }
     yield put({
          type: commonActions.SET_ALERT,
          payload: {
            status: result?.data?.statusCode === 200 ? "success" : "failed",
            show: true,
            message: result?.data?.message,
          },
        });
        yield delay(2000);
            yield put({
              type: commonActions.SET_ALERT,
              payload: { status: null, show: false, message: null },
            });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}

const getCapCategories = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/cap-category`)
    );
    if (result) {
      yield put({
        type: capRegistrationActions.SET_CAP_CATEGORY,
        payload: result?.data?.result,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}

const updateCapCategories = function* (data) {
  const { payload } = data;
  // console.log(payload)
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.put(`${API_URL}/backoffice/cap-category/${payload?.data?.categoryid}`, payload?.data)
    );
    // console.log(result)
    if (result?.data?.statusCode === 200) {
      yield put({
        type: capRegistrationActions.GET_CAP_CATEGORY,
        // payload: result?.data?.result,
      });
      payload?.navigate(
        `/${Cookies.get(
          "mhet_mst_project"
        )}/cap-category-document?page=category-documentlist`
      )
      
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}

const createCapCategories = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/cap-category`, {
        category: payload?.data?.category,
        documentid: payload?.data?.documentid,
        userid: payload?.data?.userid,
        categorynotes : payload?.data?.categorynotes,

      })
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: capRegistrationActions.GET_CAP_CATEGORY,
        // payload: result?.data?.result,
      });
      payload?.navigate(
        `/${Cookies.get(
          "mhet_mst_project"
        )}/cap-category-document?page=category-documentlist`
      )
   
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: { status: null, show: false, message: null },
        });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
}





const getAllCapCourse = function* (data) {


  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/cap-coursedetails/coursemanagement/getallcapcoursedetails`)
    );

    console.log('result ax--',result?.data);
    
    // if (result?.data?.statusCode == 200) {
      yield put({
        type: capRegistrationActions?.SET_ALL_CAP_COURSE,
        payload: result?.data?.data,
      });
    // }
    // else{
      
    // }
  } catch (err) {
     console.log(err,'error in  get all cap course');
     
  }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

};




const updateCapCourseStatus =   function*(data){
  const { payload } = data;

const {capCourseid,status}=payload;



  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/cap-coursedetails/coursemanagement/updatecoursestatus`, {capcourseid:capCourseid,status:status})
    );  


    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode == 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    yield put({
      type:capRegistrationActions?.GET_ALL_CAP_COURSE });
  } catch (error) {
    console.error("CAP Course status update Error:", error);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Failed to update status for CAP course",
      },
    });
  }
}


export default capSagas;
